import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Devices } from '../../enums/devices.enum';

@Injectable()
export abstract class DeviceManagerService {
  abstract getCurrentDevice(): Observable<Array<Devices>>;
  abstract deviceType$(): Observable<DeviceType>;
  abstract isMobileOrMobileSE(): boolean;
  abstract isDesktopOrIPAD_landscape(): boolean;
  abstract isDesktop(): boolean;
  abstract isBigDesktop(): Observable<boolean>;
  abstract isMobileOrTablet(): Observable<boolean>;
  abstract getFullUrlSSr(): string;
  abstract getBaseUrlSSr(): string;
  abstract getLocation(): string;
  abstract isLargeDesktop(): Observable<boolean>;
  abstract isAtLeastTabletWidth(): Observable<boolean>;
}
export interface DeviceType {
  isDesktop: boolean;
  bigViewPort: boolean;
  isMobile: boolean;
}
